import { sendJSONData } from '@aytm/app/stats/lib/io/fetch'
import { getCSRFParam, getCSRFToken } from '@aytm/lib/common/rails-post-fetch'

import FileUpload from '@aytm/app/stats/lib/io/file-upload'
import PageGlobals from '@aytm/app/stats/lib/page/page-globals'
import { clipText } from '@aytm/app/stats/lib/util/helpers'

const useAttachments = ({ dispatch }) => {
  // eslint-disable-next-line unicorn/consistent-function-scoping
  const FileAttach = (data, isPublic) =>
    sendJSONData({
      url: `/expert-study/${window.es_id}/attach_expert_report`,
      method: 'POST',
      data: {
        [getCSRFParam()]: getCSRFToken(),
        survey_id: PageGlobals.SURVEY_ID,
        expert_report_asset_id: data.id,
        public: isPublic ? 1 : 0
      }
    }).then(response => {
      if ('OK' == response.status) {
        window.report_exists = true
        // The study is auto-created server-side when the survey had none (es_id was -1);
        // adopt the returned id so the download path and later renders address the real study.
        window.es_id = response.expert_study_id

        window.report_asset_path = `/expert-study/${window.es_id}/report_asset/${data.filename}`
        // the same cut the page makes on load: a name longer than twelve keeps its first nine and an ellipsis
        window.report_asset_filename = 12 < data.filename.length ? `${clipText(data.filename, 9)}...` : data.filename

        const size = parseInt(data.size, 10)
        if (!Number.isNaN(size)) {
          window.report_asset_pretty_size =
            1024 * 1024 < size ? (size / (1024 * 1024)).toFixed(2) + 'Mb' : (size / 1024).toFixed(2) + 'Kb'
        } else window.report_asset_pretty_size = ''
      } else {
        return Promise.reject(response)
      }
    })

  // eslint-disable-next-line unicorn/consistent-function-scoping
  const FileDetach = () =>
    sendJSONData({
      url: `/expert-study/${window.es_id}/attach_expert_report`,
      method: 'POST',
      data: {
        [getCSRFParam()]: getCSRFToken(),
        survey_id: PageGlobals.SURVEY_ID,
        expert_report_asset_id: 0,
        public: 0
      }
    }).then(response => {
      if ('OK' == response.status) {
        window.report_exists = false
        window.report_asset_path = null
        window.report_asset_filename = null
        window.report_asset_pretty_size = null
      }

      dispatch({
        type: 'UPDATE_STATE',
        key: 'attachments',
        state: {
          progress: 0,
          processing: false
        }
      })
    })

  const onAttachmentUpload = (file, isPublic) => {
    dispatch({
      type: 'UPDATE_STATE',
      key: 'attachments',
      state: {
        failed: false,
        processing: true
      }
    })

    return FileUpload({
      file,
      uploadUrl: PageGlobals.CREATE_EXPERT_STUDY_REPORT_PATH,
      params: { 'options[expert_study_report]': window.es_id }
    })
      .then(
        data => FileAttach(data, isPublic),
        null,
        (progress, totalProgress) =>
          dispatch({
            type: 'UPDATE_STATE',
            key: 'attachments',
            state: {
              progress: parseInt((100 * progress) / totalProgress, 10)
            }
          })
      )
      .then(() =>
        dispatch({
          type: 'UPDATE_STATE',
          key: 'attachments',
          state: {
            attachments: {
              progress: 0,
              processing: false
            }
          }
        })
      )
      .catch(error =>
        dispatch({
          type: 'UPDATE_STATE',
          key: 'attachments',
          state: {
            failed: true,
            errors: Array.isArray(error?.error) ? error.error : [],
            progress: 0,
            processing: false
          }
        })
      )
  }

  const onAttachmentRemove = () => {
    dispatch({
      type: 'UPDATE_STATE',
      key: 'attachments',
      state: {
        processing: true
      }
    })

    return FileDetach()
      .then(() =>
        dispatch({
          type: 'UPDATE_STATE',
          key: 'attachments',
          state: {
            progress: 0,
            processing: false
          }
        })
      )
      .catch(() =>
        dispatch({
          type: 'UPDATE_STATE',
          key: 'attachments',
          state: {
            progress: 0,
            processing: false
          }
        })
      )
  }

  return { onAttachmentUpload, onAttachmentRemove }
}

export default useAttachments
